import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { OBJECT_getInstancerq52wx6ymebx as OBJECT_getInstance } from '../descriptors/SerialKinds.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor } from '../descriptors/SerialDescriptors.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ObjectSerializer$_get_descriptor_$ref_7z4xb6() {
  return constructCallableReference((p0) => p0.get_descriptor_wjt6a0_k$(), 1, 0, 18);
}
var ObjectSerializerClass;
function ObjectSerializer() {
  if (ObjectSerializerClass === VOID) {
    class $ {
      constructor(serialName, objectInstance) {
        return new.target.new_kotlinx_serialization_internal_ObjectSerializer_91lle8_k$(serialName, objectInstance);
      }
      static new_kotlinx_serialization_internal_ObjectSerializer_91lle8_k$(serialName, objectInstance) {
        var $this = createThis(this);
        $this.objectInstance_1 = objectInstance;
        $this._annotations_1 = emptyList();
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.descriptor$delegate_1 = lazy(tmp_0, () => {
          var tmp = OBJECT_getInstance();
          return buildSerialDescriptor(serialName, tmp, [], ($this$buildSerialDescriptor) => {
            $this$buildSerialDescriptor.annotations_1 = $this._annotations_1;
            return Unit_instance;
          });
        });
        return $this;
      }
      static new_kotlinx_serialization_internal_ObjectSerializer_ezfnxd_k$(serialName, objectInstance, classAnnotations) {
        var $this = this.new_kotlinx_serialization_internal_ObjectSerializer_91lle8_k$(serialName, objectInstance);
        $this._annotations_1 = asList(classAnnotations);
        return $this;
      }
      get_descriptor_wjt6a0_k$() {
        var tmp0 = this.descriptor$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, ObjectSerializer$_get_descriptor_$ref_7z4xb6(), null);
        return tmp0.get_value_j01efc_k$();
      }
      serialize_kj9hv3_k$(encoder, value) {
        encoder.beginStructure_yljocp_k$(this.get_descriptor_wjt6a0_k$()).endStructure_1xqz0n_k$(this.get_descriptor_wjt6a0_k$());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_kj9hv3_k$(encoder, !(value == null) ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.get_descriptor_wjt6a0_k$();
        var composite = decoder.beginStructure_yljocp_k$(descriptor);
        var tmp$ret$1;
        $l$block_0: {
          if (composite.decodeSequentially_xlblqy_k$()) {
            tmp$ret$1 = Unit_instance;
            break $l$block_0;
          }
          var index = composite.decodeElementIndex_bstkhp_k$(this.get_descriptor_wjt6a0_k$());
          if (index === -1) {
            tmp$ret$1 = Unit_instance;
            break $l$block_0;
          } else
            throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('Unexpected index ' + index);
        }
        var result = tmp$ret$1;
        composite.endStructure_1xqz0n_k$(descriptor);
        return this.objectInstance_1;
      }
    }
    initMetadataForClass($, 'ObjectSerializer', VOID, VOID, [KSerializer()]);
    ObjectSerializerClass = $;
  }
  return ObjectSerializerClass;
}
//region block: exports
export {
  ObjectSerializer as ObjectSerializer2kjkucmygguwd,
};
//endregion

//# sourceMappingURL=ObjectSerializer.mjs.map
